const initialState = {
  showBanner: false,
  bannerStatus: "",
  bannerComponentType: "",
  showNotificationBanner: false,
};

const state = initialState;

const mutations = {
  SET_SHOW_BANNER(state, showBanner) {
    state.showBanner = showBanner;

    if (showBanner === false) {
      state.bannerStatus = "";
      state.bannerComponentType = "";
    }
  },

  SET_BANNER_STATUS(state, bannerStatus) {
    state.bannerStatus = bannerStatus;
  },

  SET_BANNER_COMPONENT_TYPE(state, bannerComponentType) {
    state.bannerComponentType = bannerComponentType;
  },

  RESET_STATES(state) {
    state.showBanner = false;
    state.bannerStatus = "";
    state.bannerComponentType = "";
  },
  
  SET_NOTIFICATION_BANNER(state, notificationBannerStatus) {
    state.showNotificationBanner = notificationBannerStatus
  },
};

const actions = {
  updateShowBanner({ commit }, showBanner) {
    commit("SET_SHOW_BANNER", showBanner);
  },
  updateBannerStatus({ commit }, status) {
    commit("SET_BANNER_STATUS", status);
  },
  updateBannerComponentType({ commit }, bannerComponentType) {
    commit("SET_BANNER_COMPONENT_TYPE", bannerComponentType);
  },
  resetAllStates({ commit }) {
    commit("RESET_STATES");
  },
  updateNotificationBanner({ commit }, status) {
    commit("SET_NOTIFICATION_BANNER", status)
  }
};

const getters = {
  getShowBanner: (state) => state.showBanner,
  getBannerStatus: (state) => state.bannerStatus,
  getBannerComponentType: (state) => state.bannerComponentType,
  getNotificationBannerStatus: (state) => state.showNotificationBanner,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
